import { queryConstants } from './constants/queryConstants';

const listQueries = (data: any) => ({
  type: queryConstants.listQueriesRequest,
  payload: data
});

const saveQuery = (data: any) => ({
  type: queryConstants.saveQueryRequest,
  payload: data
});

const viewQuery = (data: any) => ({
  type: queryConstants.viewQueryRequest,
  payload: data
});

const deleteQuery = (data: any) => ({
  type: queryConstants.deleteQueryRequest,
  payload: data
});

const addRemarks = (data: any) => ({
  type: queryConstants.addRemarksRequest,
  payload: data
});

export const queryActions = {
  listQueries,
  saveQuery,
  viewQuery,
  deleteQuery,
  addRemarks
};
